import TagManagerUtils from '../../../utils/TagManagerUtils';

const tiposContrato = (
    contratosServicio,
    storeDataVerificacion,
    datosLaborales,
    state,
    setState,
    setDatosLaborales
    ) => {
    const { tiposContratos } = contratosServicio;
    if (tiposContratos) {
      const { data } = storeDataVerificacion;
      const { codigoTipoContrato, convenio, socio } = data;

      // TagManagerUtils
      let TextoSocio;
      if (socio && convenio) {
        TextoSocio = 'Socio convenio';
      } else if (socio) {
        TextoSocio = 'Socio';
      } else {
        TextoSocio = 'No socio';
      }
      TagManagerUtils.vpvMetodo('vpv', '/solicitud-tarjeta-credito/paso2a', TextoSocio);

      // si es un socio con convenio se autocompleta tipo contrato
      if (socio && convenio) {
        const { formularioTrabajadorDependiente } = datosLaborales;
        const filtroContratos = tiposContratos.filter(function (e) {
          return e.codigo === parseInt(codigoTipoContrato, 10);
        });

        formularioTrabajadorDependiente[0].contrato = codigoTipoContrato;
        setState({
          ...state,
          conJuntoDeContratos: tiposContratos,
        });

        if (filtroContratos.length) {
          setDatosLaborales({
            ...datosLaborales,
            contratoSeleccionado: {
              codigo: filtroContratos[0].codigo,
              descripcion: filtroContratos[0].descripcion,
            },
            formularioTrabajadorDependiente,
          });
        } else {
          setDatosLaborales({
            ...datosLaborales,
            formularioTrabajadorDependiente,
          });
        }
      }

      setState({
        ...state,
        conJuntoDeContratos: tiposContratos,
      });
    }
};

export default tiposContrato;